import { useLanguage } from "../context/LanguageContext";

const Diamond = () => (
  <svg viewBox="0 0 24 24" className="h-3 w-3 shrink-0" aria-hidden="true">
    <path d="M12 3 L21 12 L12 21 L3 12 Z" fill="#E3302A" />
  </svg>
);

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-ink-700/60 bg-ink-900/60 py-4"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-8 hover:[animation-play-state:paused]">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-8">
            {items.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-8 whitespace-nowrap font-display text-lg font-semibold uppercase tracking-[0.2em] text-zinc-400"
              >
                {item}
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
